/**
 * Formats prices with Figma decimal styling (7629:210). Used by installments + variant price updates.
 */
(function () {
  'use strict';

  const NIS = '₪';

  function parseMoneyString(raw) {
    const value = String(raw || '').trim();
    let whole = value;
    let cents = '';
    let decimalSep = '.';

    if (!value) return { whole: '0', cents: '00', decimalSep };

    if (value.includes('.') && value.includes(',')) {
      const afterDot = value.split('.').pop();
      if (afterDot.includes(',')) {
        decimalSep = ',';
        const segs = value.split(',');
        whole = segs[0];
        if (segs.length > 1) cents = segs[1];
      } else {
        decimalSep = '.';
        const segs = value.split('.');
        whole = segs[0];
        if (segs.length > 1) cents = segs[1];
      }
    } else if (value.includes(',')) {
      const segs = value.split(',');
      const tail = segs[segs.length - 1];
      if (segs.length === 2 && tail.length <= 2) {
        decimalSep = ',';
        whole = segs[0];
        cents = tail;
      }
    } else if (value.includes('.')) {
      const segs = value.split('.');
      const tail = segs[segs.length - 1];
      if (segs.length === 2 && tail.length <= 2) {
        decimalSep = '.';
        whole = segs[0];
        cents = tail;
      } else if (segs.length > 2 && tail.length <= 2) {
        decimalSep = '.';
        cents = tail;
        whole = segs.slice(0, -1).join('.');
      }
    }

    return { whole: whole || '0', cents: padCents(cents), decimalSep };
  }

  function padCents(cents) {
    if (!cents) return '00';
    return cents.length === 1 ? cents + '0' : cents;
  }

  function stripCurrencySymbols(formatted) {
    return String(formatted || '')
      .replace(/₪/g, '')
      .replace(/[^\d.,\s'-]/g, '')
      .trim();
  }

  function formatMajor(amountMajor) {
    const n = Number(amountMajor);
    if (!Number.isFinite(n)) return '0.00';

    const tpl = window.FoxTheme?.settings?.moneyFormat || window.current_product?.money_format;
    if (tpl && window.FoxTheme?.Currency?.formatMoney) {
      const cents = Math.round(n * 100);
      return stripCurrencySymbols(window.FoxTheme.Currency.formatMoney(cents, tpl));
    }

    return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function renderHtml(amountMajor, variant) {
    const parts = parseMoneyString(formatMajor(amountMajor));
    const allowed = { sale: 1, compare: 1, regular: 1, installment: 1 };
    const v = allowed[variant] ? variant : 'sale';
    const whole = parts.whole;
    const sep = parts.decimalSep;
    const cents = parts.cents;

    if (v === 'compare') {
      return (
        '<span class="wd-price-amount" data-wd-price-variant="compare" dir="ltr">' +
        '<s class="wd-price-amount__strike">' +
        '<span class="wd-price-amount__currency">' + NIS + '</span>' +
        '<span class="wd-price-amount__digits">' + whole + '</span>' +
        '<span class="wd-price-amount__point">' + sep + '</span>' +
        '<span class="wd-price-amount__cents">' + cents + '</span>' +
        '</s>' +
        '</span>'
      );
    }

    return (
      '<span class="wd-price-amount" data-wd-price-variant="' + v + '" dir="ltr">' +
      '<span class="wd-price-amount__currency">' + NIS + '</span>' +
      '<span class="wd-price-amount__digits">' + whole + '</span>' +
      '<span class="wd-price-amount__decimal">' + sep + cents + '</span>' +
      '</span>'
    );
  }

  function setElementHtml(el, amountMajor, variant) {
    if (!el) return;
    el.innerHTML = renderHtml(amountMajor, variant);
  }

  /**
   * Writes add-on totals into visible PDP prices.
   * Non-sale products show `.f-price__regular .f-price-item--regular` (sale node is hidden).
   */
  function updateProductPrices(saleMajor, compareMajor) {
    const sale = Number(saleMajor);
    const compare = Number(compareMajor);
    if (!Number.isFinite(sale)) return;

    const onSale = Number.isFinite(compare) && compare > sale + 0.005;
    const roots = document.querySelectorAll(
      '.product__block--price .f-price, .product__block--price .wd-price, .wd-total-price .f-price, .wd-buy-btn .f-price'
    );

    roots.forEach((root) => {
      root.classList.toggle('f-price--on-sale', onSale);

      const saleEl = root.querySelector('.f-price__sale .f-price-item--sale');
      const regularEl = root.querySelector('.f-price__regular .f-price-item--regular');
      let compareEl = root.querySelector('.f-price__sale .f-price-item--regular');

      setElementHtml(saleEl, sale, 'sale');
      setElementHtml(regularEl, sale, 'regular');

      if (onSale) {
        if (!compareEl) {
          const saleWrap = root.querySelector('.f-price__sale');
          if (!saleWrap) return;
          compareEl = document.createElement('span');
          compareEl.className = 'f-price-item f-price-item--regular';
          saleWrap.appendChild(compareEl);
        }
        setElementHtml(compareEl, compare, 'compare');
      }
    });
  }

  document.addEventListener('priceChange', (e) => {
    const totalPrice = e.detail?.totalPrice;
    if (totalPrice == null) return;
    updateProductPrices(totalPrice, e.detail.totalCompare ?? totalPrice);
  });

  window.WDPriceFormat = {
    formatMajor,
    parseMoneyString,
    renderHtml,
    setElementHtml,
    updateProductPrices,
    padCents,
  };
})();
